import React from "react";
// Styles
import "./style.scss";

const TrustSeals = ({ images = [] }) => {
  return (
    <div className="trust-seals">
      {images.map(({ url }, index) => (
        <img src={url} key={index} alt="Trust seal" />
      ))}
    </div>
  );
};

export default TrustSeals;
